import React from 'react';
import PropTypes from 'prop-types';
import UserPlaylistContainer from './UserPlaylistContainer';
import { UserPlaylistConsumer } from './UserPlaylistQuery';

const UserPlaylistRenderer = ({ props }) => (
  <UserPlaylistConsumer>
    {({ component: Component, ...contextProps }) => {
      if (props) {
        const RenderedComponent = Component || UserPlaylistContainer;
        return (
          <RenderedComponent {...contextProps} {...props} />
        );
      }
      return <div>Loading...</div>;
    }}
  </UserPlaylistConsumer>
);

UserPlaylistRenderer.propTypes = {
  component: PropTypes.node,
  props: PropTypes.object
};

export default UserPlaylistRenderer;



// WEBPACK FOOTER //
// ./webpack/components/App/UserPlaylistRenderer.js